const defaultCredentialsForm = {
    id: '',
    nombre_portal: null,
    url: '',
    username: null,
    password: null,
    cookie: null,
    created_on: null,
    updated_on: null,
}

export default defaultCredentialsForm;